// extracted by mini-css-extract-plugin
export default {"content":"TabRelacionesComponet_content__0W0MB","nav":"TabRelacionesComponet_nav__cJ1+A","a":"TabRelacionesComponet_a__Ejyw5","a1":"TabRelacionesComponet_a1__zUpMF"};